module.exports = __webpack_public_path__ + "static/media/1.ed986061.jpeg";